import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './UserOnboardingPage.css';
import { cancelSubscription, createNewSubscription, getPaymentMethods } from '../../api/password';
import "../../components/SubscriptionOptions/SubscriptionOptions.css";
import { notification, Row, Col } from 'antd';

const SubscriptionConfirmation2 = () => {
  const location = useLocation();
  const subscriptionId = location.state?.subscriptionId;
  const couponResponse = location.state?.couponResponse;
  const navigate = useNavigate();
  const { selectedOption } = location.state || {};
  const [hasPaymentMethods, setHasPaymentMethods] = useState(false);

  useEffect(() => {
    const fetchPaymentMethods = async () => {
      try {
        const response = await getPaymentMethods();
        if (response.paymentMethods.length > 0) {
          setHasPaymentMethods(true);
        }
      } catch (error) {
        console.error('Error fetching payment methods:', error);
        setHasPaymentMethods(false);
      }
    };
    fetchPaymentMethods();
  }, []);

  if (!selectedOption) {
    navigate('/subs2');
    return null;
  }
 const subscriptionDetails = location?.state?.subscriptionDetails;
 const handleBack = () => {
    navigate('/subs2', {
      state: {
        subscriptionDetails: subscriptionDetails
      }
    });
  };

  const handleCancelSubscription = async () => {
    try {
      const response = await cancelSubscription();
      if (response.error) {
        notification.error({ message: 'Cancel Subscription Error', description: response.error, duration: 10 });
      } else {
        notification.success({ message: 'Subscription Canceled', description: 'Your subscription has been canceled successfully.', duration: 10 });
      }
    } catch (error) {
      notification.error({ message: 'Cancel Subscription Error', description: error.message, duration: 10 });
    }
  };



  let discountedPrice = selectedOption.price;
  let discountPercentage = 0;
  let discountCode = '';
  let discountValidFor = '';
  let discountAmount = 0;
     

  if (couponResponse) {

    const discountInfo = couponResponse.discount;

    if (discountInfo) {
      discountPercentage = discountInfo.discountPercentage || 0;
      discountCode = discountInfo.discountCode || '';

      const priceString = selectedOption.pkg.replace('£', '');
      const originalPrice = parseFloat(priceString);

      if (!isNaN(originalPrice)) {
        discountAmount = (discountPercentage / 100) * originalPrice;
        discountedPrice = (originalPrice - discountAmount).toFixed(2);
      } else {
        console.error("Failed to parse original price from:", priceString);
      }

      discountValidFor = `${discountInfo.discountPeriod} month${discountInfo.discountPeriod > 1 ? 's' : ''}`;
    } else {
      console.error("Discount information is missing in couponResponse");
    }
  }
    const handleConfirm = async () => {
    // Use planId from the selected option (either database ID or stripePlanId from API)
    const planId = selectedOption.planId || selectedOption.stripePlanId;
    
    if (!planId) {
      console.error('No planId found in selected option');
      notification.error({
        message: 'Error',
        description: 'Unable to determine plan ID. Please try again.',
        duration: 10
      });
      return;
    }

    const couponAmount = discountAmount ? parseFloat(discountAmount.toFixed(2)) : null;
    let couponDurationMonths = discountValidFor ? parseInt(discountValidFor) : null;

    if (selectedOption.title === 'Pay Annually') {
      couponDurationMonths = 1;
    }

      navigate('/payment', { state: { selectedPlan: selectedOption, subscriptionId: subscriptionId, coupon: couponResponse?.discount?.discountCode, couponAmount: couponAmount, couponDurationMonths: couponDurationMonths } });
  };

  return (
    // <div className="subscription-confirmation">
    //   <h1>Confirm Your Subscription</h1>
    //   <p className='text'>Ensure that you are happy with your chosen subscription and confirm below to proceed to payment.</p>
     
    //   <div className="selected-plan">
    //     <h2>{selectedOption.title}</h2>
    //     <div className="desc">
    //       {selectedOption.desc.map((desc, index) => (
    //         <p key={index}>{desc}</p>
    //       ))}
    //     </div>
    //     <div className='plan'>
    //       <p className='pkg'>{selectedOption.pkg}</p>
    //       <p className='price'>{selectedOption.price}</p>
    //     </div>
        
    //     <button className="confirmed-button" onClick={handleConfirm}>Confirmed</button>
    //     <p className='detail'>{selectedOption.detail.join(' ')}</p>
    //   </div>

    //   <div className="actions">
    //     <button className="back-button" onClick={handleBack}>Go Back</button>
    //     <button className="confirm-button" onClick={handleConfirm}>Confirm</button>
    //   </div>
    //   <div>
    //     <button className = "cancel-subscription" onClick={handleCancelSubscription}>Cancel Subscription</button>
    //   </div>
    // </div>
    <div>
      <Row className="welcome-onboarding-row confirmed-plan">
        <Row gutter={24} className="chose-subscription-text-container">
          <Col span={24}>
            <span
              className="heading text-align-center"
              style={{ display: "block" }}
            >
              Choose Your Subscription
            </span>
          </Col>
        </Row>
        <Row gutter={24} className="chose-subscription-text-container">
          <Col className="flex-justify-center">
            <span className="text chose-subscription-description-text">
              Ensure that you are happy with your chosen subscription and confirm below to proceed to payment.
            </span>
          </Col>
        </Row>
         <div className="subscription-options-container">
            <Row gutter={24} className="justify-content-center flex-justify-space-center">
              <Col xs={24} sm={24} md={12} lg={8}>
                <div className="height-fit-content subscription-option selected">
                  <Row className="heading-description-container">
                     <h2 className="text-align-center" style={{ display: "block" }}>
                        {selectedOption.title}
                      </h2> 
                      <div className="desc">
                        {selectedOption.desc.map((desc, index) => (
                          <p className="lh-24" key={index}>{desc}</p>
                        ))}
                      </div>
                  </Row> 
                  <Row className="price-container">
                    <div>
                      {couponResponse === null ? (
                        <div className='plan'>
                          <p className='pkg'>{selectedOption.pkg}</p>
                          <p className='price'>{selectedOption.price}</p>
                        </div>
                      ) : (
                        <div className='plan-confirm-subscription' style={{ display: 'flex', flexDirection: 'column' }}>
                          <p
                            className='pkg'
                            style={{
                              fontSize: '42px',
                              margin: '0',
                              textDecoration: 'line-through',
                              color: '#999',
                            }}
                          >
                            {selectedOption.pkg} {selectedOption.price}
                          </p>
                          <div>
                            <p style={{ margin: '5px 0', fontSize: '14px' }}>
                              Discount: {discountPercentage}%
                            </p>
                            <p style={{ margin: '5px 0', fontSize: '14px' }}>
                              Discount Code: {discountCode}
                            </p>
                            <p style={{ margin: '5px 0', fontSize: '14px' }}>
                              You Pay: £{discountedPrice}
                            </p>
                            <p style={{ margin: '5px 0', fontSize: '14px' }}>
                              Discount Valid for: {discountValidFor}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      <ul className="details">
                        {selectedOption.details.map((details, index) => (
                          <li key={index}>{details}</li>
                        ))}
                      </ul>
                    </div>
                  </Row>
                  <Row justify={"center"}> <button className="confirmed-button" onClick={handleConfirm}>Confirmed</button>
                  </Row>
                  <Row style={{ height: "auto" }}>
                    <div className="detail">
                      {selectedOption.detail.map((detail, index) => (
                        <p className="lh-18" key={index}>{detail}</p>
                      ))}
                    </div>
                  </Row>
                </div>
              </Col>
            </Row>
         </div>
      </Row>
       <Row gutter={24} className="justify-content-center flex-justify-space-center">
          <Col style={{ display: "flex" }} className="mb-3 flex-justify-center" xs={24} sm={24} md={8} lg={4}>
            <button className="back-button" onClick={handleBack}>Go Back</button> 
          </Col>
          <Col style={{ display: "flex" }} className="mb-3 flex-justify-center" xs={24} sm={24} md={8} lg={4}>
            <button className="sub-confirm-button" onClick={handleConfirm}>Confirm</button>  
          </Col>
        </Row>  
    </div>
  );
};

export default SubscriptionConfirmation2;
